module.exports = import("https://cdn.skypack.dev/cannon-es");;